import React, { useState, useRef, useEffect } from "react";
import '../../../scss/TypeTracNghiem.scss'
import he from 'he';
import { ThiTrucTuyenService } from 'services/ThiTrucTuyenService';
import { RadioButton } from "primereact/radiobutton";
import { Toast } from 'primereact/toast';

const TypeTracNghiem = (props) => {
    const { data, onChangeValue, isNhom, userId, time, overview, thitructuyen } = props;
    const isExample = data?.is_example == 1;
    // Nếu là câu example, tự động chọn đáp án có is_example = 1
    const exampleAnswer = isExample ? data?.lstdapan?.find(item => item.is_example == 1) : null;
    const [dataSelected, setdataSelected] = useState(
        isExample && exampleAnswer ? exampleAnswer.id : (data?.selected?.id_cautraloi || 0)
    );
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const toast = useRef(null);
    const IdDeThi = localStorage.getItem('IdDeThi');
    // Sync state khi chuyển câu (props.data thay đổi) để hiển thị lại đáp án đã chọn
    useEffect(() => {
        const newVal = isExample && exampleAnswer ? exampleAnswer.id : (data?.selected?.id_cautraloi || 0);
        setdataSelected(newVal);
    }, [data?.id, data?.selected?.id_cautraloi]);
    const getLetterLabel = (index) => {
        return String.fromCharCode(65 + index); // 65 là mã ASCII của 'A'
    };
    const onChange = (idAnswer) => {
        if (isExample) return; // Không cho chọn đáp án khi là câu hỏi mẫu
        setdataSelected(idAnswer);
        if (!isNhom) {
            onChangeValue(idAnswer);
        }
        onSubmitQuestion(data.id, idAnswer);
    }
    const onSubmitQuestion = async (idquestion, idAnswer) => {
        const attemptCode = localStorage.getItem('exam_attempt_code');
        const typeExam = localStorage.getItem('typeExam');
        const IdDeThi = localStorage.getItem('IdDeThi');
        let body = {
            id_cauhoi: idquestion,
            id_cautraloi: idAnswer,
            thoigianconlai: time,
            user_id: userId,
            loaibaithi: 1,
            attempt_code: attemptCode || null,
            dethitructuyen_id: IdDeThi,
            type_exam: typeExam
        }
        await ThiTrucTuyenService.submitquestion(body);
    }

    const toggleAudio = async () => {
        try {
            const el = audioRef.current;
            if (!el) return;

            const playCountKey = `playCount_${userId}_${data.id}_${IdDeThi}`;
            const currentCount = parseInt(localStorage.getItem(playCountKey) || '0');

            if (isPlaying) {
                el.pause();
                setIsPlaying(false);
            } else {
                if (currentCount >= 2) {
                    toast.current.show({
                        severity: 'warn',
                        summary: 'Thông báo',
                        detail: 'Bạn đã hết lượt nghe cho câu hỏi này (tối đa 2 lần).',
                        life: 3000
                    });
                    return;
                }

                // Nếu bắt đầu nghe (lượt 1 hoặc 2), thì nghe lại từ đầu
                el.currentTime = 0;
                await el.play();
                setIsPlaying(true);

                const newCount = currentCount + 1;
                localStorage.setItem(playCountKey, newCount);
            }
        } catch (e) {
            // ignore play error
        }
    };

    const filteredRecords = data.lstdapan.filter(item => item.chinhxac == 1);
    return (
        <>
            <div className="conatiner-div1">
                <div>
                    <div>
                        {isExample && (
                            <span style={{
                                display: 'inline-block',
                                padding: '2px 10px',
                                backgroundColor: '#fff3cd',
                                border: '1px solid #ffc107',
                                borderRadius: '6px',
                                fontSize: '13px',
                                fontWeight: '600',
                                color: '#856404',
                                marginRight: '8px',
                                marginBottom: '8px',
                                verticalAlign: 'middle'
                            }}>
                                ⚡ Example
                            </span>
                        )}
                        <div style={{ width: '100%' }}
                            dangerouslySetInnerHTML={{
                                __html: he.decode(data.vanbancauhoi)
                            }}
                        />
                    </div>
                    <div>
                        {data.file && data.file.includes('.mp3') &&
                            <div style={{ marginTop: '20px', width: '100%' }}>
                                <audio
                                    controlsList="nodownload"
                                    key={data.id}
                                    ref={audioRef}
                                    style={{ display: 'none' }}
                                    onEnded={() => setIsPlaying(false)}
                                >
                                    <source src={data.file} type="audio/ogg" />
                                    <source src={data.file} type="audio/mpeg" />
                                </audio>
                                <button
                                    type="button"
                                    className="btn-audio-toggle"
                                    onClick={toggleAudio}
                                >
                                    <span className="icon">{isPlaying ? '⏸' : '⏵'}</span>
                                    <span className="text">
                                        <u>{isPlaying ? 'Stop' : 'Play'}</u>
                                    </span>
                                </button>
                            </div>
                        }
                    </div>

                    <div style={{ marginBottom: data.isnhom ? '100px' : '10px', marginTop: '20px' }}>
                        {data && data.lstdapan.filter(item => item.vanbanphanhoi != null && item.vanbanphanhoi !== '').map((item, index) => {
                            const isSelected = item.id == dataSelected;
                            const isCorrect = item.chinhxac == 1;
                            const showCorrectTick = overview && !isExample && isCorrect;
                            const showWrongTick = overview && !isExample && isSelected && !isCorrect;
                            return (
                                <div
                                    className={`tn-option d-flex ${isSelected ? 'selectedoption' : ''}`}
                                    key={index}
                                    onClick={() => onChange(item.id)}
                                    style={{
                                        ...(overview ? {
                                            border: showWrongTick
                                                ? '2px solid #dc2626'
                                                : (showCorrectTick ? '2px solid #16a34a' : undefined),
                                            backgroundColor: showWrongTick
                                                ? '#fef2f2'
                                                : (showCorrectTick ? '#f0fdf4' : undefined)
                                        } : {}),
                                        ...(isExample ? {
                                            pointerEvents: 'none',
                                            opacity: isSelected ? 1 : 0.6,
                                            ...(isSelected ? {
                                                backgroundColor: '#fef3c7',
                                                border: '2px solid #f59e0b',
                                            } : {})
                                        } : {})
                                    }}
                                >
                                    <RadioButton
                                        inputId={item.id}
                                        name={"radio_" + data.id}
                                        checked={isSelected}
                                        className="tn-radio-hidden"
                                        disabled={isExample}
                                    />
                                    <label className="tn-label">
                                        <span className="tn-letter">{getLetterLabel(index)}</span>
                                        <span className="tn-text" dangerouslySetInnerHTML={{ __html: he.decode(item.vanbanphanhoi) }} />
                                        {showCorrectTick && <span style={{ marginLeft: 10, color: '#16a34a', fontWeight: 700 }}>✓</span>}
                                        {showWrongTick && <span style={{ marginLeft: 10, color: '#dc2626', fontWeight: 700 }}>✗</span>}
                                    </label>
                                </div>
                            )
                        })}
                        {
                            data.vanbangiaithich && overview &&
                            <div style={{ color: 'red', marginLeft: 10 }}>
                                <div style={{ fontWeight: '600' }}>Giải thích :</div>
                                <span style={{ color: 'black' }} dangerouslySetInnerHTML={{ __html: data.vanbangiaithich }}></span>
                            </div>
                        }

                    </div>
                </div>

            </div>
            <Toast ref={toast} />
        </>
    );
}

export default TypeTracNghiem;